import locationsDetailsImg from './location-details.png'
import locationsListImg from './locations-list.png'

export const images = {
  locationsDetailsImg,
  locationsListImg,
}
